import backend from './backend';
import compare from './compare.js';
import global from './global';
import pdp from './pdp';
import user from './user';
import storage from './storage';
import savedLists from './saved-lists.js';
import cart from './cart.js';
import miniCart from './mini-cart.js';
import notifications from './notifications.js';
import warrantyClaims from './warranty-claims.js';
import advancedOrdering from './advanced-ordering.js';
import plp from './plp.js';
import skuGrid from './sku-grid';
import storeLocator from './store-locator';
import productFeedback from './product-feedback.js';
import productBundle from './product-bundle.js';
import powerReviews from './power-reviews.js';
import productStockData from './product-stock-data.js';
import retailerSearch from './retailer-search';

export {
  backend,
  compare,
  global,
  pdp,
  user,
  storage,
  savedLists,
  cart,
  miniCart,
  notifications,
  warrantyClaims,
  advancedOrdering,
  plp,
  skuGrid,
  storeLocator,
  productFeedback,
  productBundle,
  powerReviews,
  productStockData,
  retailerSearch,
};
